import React from 'react';
import { cn } from '../../../lib/utils';
import { useTheme } from '../../../contexts/ThemeContext';

const PERIOD_OPTIONS = [
  { value: 3, label: '3 months' },
  { value: 6, label: '6 months' },
];

/**
 * Badge-style period picker for Implementation Evaluation (ΠΑΡ.2).
 */
const ImplementationEvaluationPeriodBadges = ({ value, onChange, disabled = false }) => {
  const { theme } = useTheme();
  const selected = value == null || value === '' ? null : Number(value);

  return (
    <div className="mt-1 flex flex-wrap items-center gap-2" role="radiogroup" aria-label="Required period">
      {PERIOD_OPTIONS.map((option) => {
        const isSelected = selected === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            onClick={() => {
              if (disabled) return;
              // Toggle off if clicking the same value
              onChange?.(isSelected ? null : option.value);
            }}
            className={cn(
              'inline-flex items-center rounded-full px-3.5 py-1.5 text-sm font-medium transition-all duration-150',
              'border focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1',
              isSelected
                ? 'border-blue-500 bg-blue-600 text-white shadow-sm'
                : cn(
                    'border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50',
                    'dark:border-gray-600 dark:bg-transparent dark:hover:border-blue-500 dark:hover:bg-blue-950/40',
                    theme.text.primary,
                  ),
              disabled && 'cursor-not-allowed opacity-50',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ImplementationEvaluationPeriodBadges;
export { PERIOD_OPTIONS };
